<div class="modal-content">
  <div class="modal-header text-center">
    <h3 class="modal-title">ASSINATURA ELETRÔNICA</h3>
    Como seu cliente deseja assinar estes documentos?
  </div>
  <div class="modal-body text-center">
    <section class="opcao">
      <h3>CELULAR</h3>
      <div class="conteudo">
        O Cliente irá receber uma mensagem no celular cadastrado <br>
        <strong>({{ celular.ddd }} {{ celular.nrTelefone }})</strong><br>
        com as informações do contrato e como assina-lo.
      </div>
      <div class="action">
          <app-animated-button
            label="Enviar mensagem"
            afterLabel="Enviado!"
            [onclick]="criaEnvelopeAssinatura.bind(this, tipoAssinatura.SMS)"
            [onerror]="showError"></app-animated-button>
          <a (click)="reenviaEnvelopeAssinatura(tipoAssinatura.SMS)" *ngIf="enviouSolicitacao">Não chegou? Reenviar!</a>
      </div>
    </section>

    <section class="opcao" *ngIf="proposta?.cliente?.email">
      <h3>E-MAIL</h3>
      <div class="info">
        <a (click)="alterarEmail()">Não é este e-mail? Alterar</a>
      </div>
      <div class="conteudo">
        O Cliente irá receber um link no celular cadastrado <br>
        <strong>({{ proposta?.cliente?.email }})</strong><br>
        com as informações do contrato e como assina-lo.
      </div>
      <div class="action">
        <app-animated-button
          label="Enviar E-mail"
          afterLabel="Enviado!"
          [onclick]="criaEnvelopeAssinatura.bind(this, tipoAssinatura.EMAIL)"
          [onerror]="showError"></app-animated-button>
        <a (click)="reenviaEnvelopeAssinatura(tipoAssinatura.EMAIL)" *ngIf="enviouSolicitacao">Não chegou? Reenviar!</a>
      </div>
    </section>

    <section class="opcao">
      <h3>Token</h3>
      <div class="conteudo">
        O Cliente irá receber uma mensagem no celular cadastrado <br>
        <strong>({{ celular.ddd }} {{ celular.nrTelefone }})</strong> com um código Token.<br>
        Este processo deve ser finalizado pelo cliente.
      </div>
      <div class="action">
        <app-animated-button
          label="Enviar Token"
          afterLabel="Enviado!"
          [onclick]="criaEnvelopeAssinatura.bind(this, tipoAssinatura.TOKEN)"
          [onerror]="showError"></app-animated-button>
        <a (click)="reenviaEnvelopeAssinatura(tipoAssinatura.TOKEN)" *ngIf="enviouSolicitacao">Não chegou? Reenviar!</a>
      </div>
    </section>

  <div class="modal-footer">
    <button class="btn btn-border-orange" (click)="close()">Voltar</button>
  </div>
</div>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
